import React from 'react';

const Blogs = () => {
    return (
        <div>
            <h1 className='text-5xl font-bold text-center mt-10 mb-40' style={{ color: '#65647C' }}>Comming Soon...</h1>
        </div>
    );
};

export default Blogs;